import { render, staticRenderFns } from "./ScaffoldCreateWizard.vue?vue&type=template&id=6e3fafdf&scoped=true"
import script from "./ScaffoldCreateWizard.vue?vue&type=script&lang=js"
export * from "./ScaffoldCreateWizard.vue?vue&type=script&lang=js"
import style0 from "./ScaffoldCreateWizard.vue?vue&type=style&index=0&id=6e3fafdf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3fafdf",
  null
  
)

export default component.exports